import { createActions, handleActions, combineActions } from 'redux-actions';

const defaultState = {
    regUser: false,
    authError: {},
    user: {}
};

export const { authBegin, saveAuth, regUser, authError } = createActions(
    'SAVE_AUTH',
    'REG_USER',
    'AUTH_ERROR',
    'AUTH_BEGIN'
);

export default handleActions(
    {

        [authBegin]: (
            state,
            { data = {} }
        ) => {
            return defaultState;
        },
        [regUser]: (
            state,
            { data = {} }
        ) => {
            return { ...state, regUser: true };
        },
        [saveAuth]: (
            state,
            { payload = {} }
        ) => {
            return { ...state, user: payload };
        },
        [authError]: (
            state,
            { payload = {} }
        ) => {
            console.log(payload);
            return { ...state, authError: payload };
        },

    },
    defaultState
);